/// <reference types="@angular/localize" />

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

if (!isLocalhost) {
  pdfDefaultOptions.assetsFolder = 'https://cdn.jsdelivr.net/npm/ngx-extended-pdf-viewer@25.6.4/assets';
}

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })],
}).catch(err => console.error(err));
